import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonJa from "@/locales/ja/common.json";
import authJa from "@/locales/ja/auth.json";
import errorsJa from "@/locales/ja/errors.json";
import storagesJa from "@/locales/ja/storages.json";
import appBindingsJa from "@/locales/ja/app-bindings.json";
import dashboardJa from "@/locales/ja/dashboard.json";
import auditLogJa from "@/locales/ja/audit-log.json";
import adminJa from "@/locales/ja/admin.json";

const resources = {
  ja: {
    common: commonJa,
    auth: authJa,
    errors: errorsJa,
    storages: storagesJa,
    "app-bindings": appBindingsJa,
    dashboard: dashboardJa,
    "audit-log": auditLogJa,
    admin: adminJa,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ja",
  defaultNS: "common",
  ns: ["common", "auth", "errors", "storages", "app-bindings", "dashboard", "audit-log", "admin"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
